import { AppGrid } from "@/components/AppGrid/AppGrid";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { dealModel, DealRecord } from "@/models/deal";
import { getDefaultDealDirectoryEntity } from "@/models/dealDirectory";
import { getPaletteById } from "@/models/tag";
import { userIsCreatorConstraint } from "@/orm/model";
import { PartialEntityRecord } from "@/orm/types";
import { Box } from "@mantine/core";
import { useAtomValue } from "jotai";
import { colDefs, defaultColDef } from "../colDefs";

export const Main = () => {
  const dealDirectoryAcitveRecord = getDefaultDealDirectoryEntity();
  const queryAtom =
    dealDirectoryAcitveRecord.getObserveManyBelongingsAtom<DealRecord>(
      dealModel,
      "belongsToDealDirectoryIds",
      { constraints: [userIsCreatorConstraint()] },
    );

  const dealDirectoryResult = useAtomValue(
    getDefaultDealDirectoryEntity().getObserveEntityRecordAtom(),
  );

  const update = (id: string, data: PartialEntityRecord<DealRecord>) => {
    const record = dealModel.createEntityInstance({ id });
    return record.update(data);
  };

  const { isPlanInactive } = useIsPlanInactive();

  return (
    <Box
      bg="gray"
      style={{
        width: "100%",
        height: "100%",
        justifySelf: "stretch",
        alignSelf: "stretch",
        flex: 1,
      }}
    >
      <AppGrid
        queryAtom={queryAtom}
        isReadOnly={isPlanInactive}
        id={"deal"}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        onCellValueChanged={(event) => {
          update(event.data.id, event.data);
        }}
        getRowStyle={(params) => {
          const statusTags = dealDirectoryResult.data?.progressStatusTags || [];

          const tag = statusTags.find(
            (tag) => tag.id === params.data?.progressStatusTagIds?.[0],
          );

          return {
            boxShadow:
              `inset 5px 0 0 0 ` +
              getPaletteById(tag?.paletteId || "")?.backgroundColor,
          };
        }}
      />
    </Box>
  );
};
